import { Injectable } from '@angular/core';
import { Facultativo } from '../../models/api';
import { SearchInput } from '../../models/components';
import { AppState } from '../../models/state';
import { NavService } from '../nav.service';
import { StateService } from '../state.service';

@Injectable({
  providedIn: 'root'
})
export class SearchItemHelperService {

  constructor(
    private stateService: StateService,
    private nav: NavService
  ) { }

  onMoreInfo(state: Partial<AppState>, input: Partial<SearchInput> | Partial<Facultativo>) {
    this.stateService.updateState({
      ...state,
      dataMoreInfo: input
    });
    this.nav.navigateWithBackButton('search-detail', {
      headerTitle: state.tabIndex === 0
        ? 'Información del centro'
        : 'Información del facultativo'
    });
  }
}
